module.exports = __webpack_public_path__ + "static/media/deuex.e3593c8b.svg";